import { render } from "./Ringbacalls.vue?vue&type=template&id=5043578b&scoped=true"
import script from "./Ringbacalls.vue?vue&type=script&lang=js"
export * from "./Ringbacalls.vue?vue&type=script&lang=js"

import "./Ringbacalls.vue?vue&type=style&index=0&id=5043578b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5043578b"]])

export default __exports__